<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { ChecklistCriteria, CriteriaInstance } from "~/types/Checklist";

var props = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  checklistCriteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
  maxPoints: {
    type: Number,
    required: false,
  },
});

const documentId = inject("documentId") as any;

const evaluationResultsStore = useStepResultsStore(documentId);
// calculateSuggestedScore();

const updateScore = (event: number) => {
  evaluationResultsStore.updateManualPoints(event);
};

const { earnedPoints } = storeToRefs(evaluationResultsStore);

const isDisabled = computed(() => {
  return props.criteriaInstance.evaluationMethod == "paragraph";
});

const checkAllCriteria = () => {
  evaluationResultsStore.checkAllCriteria();
}

</script>

<template>
  <div
    data-step-id="criteria-score-container"
    id="criteria-score-container"
    class="flex flex-row justify-between items-center rounded border border-medium-default bg-light-default p-2"
  >
    <span class="text-body-1 font-bold"> Suggested Points: </span>
    <BaseScoreInput
      :value="earnedPoints"
      @input="updateScore"
      @check-all-criteria="checkAllCriteria"
      :disabled="isDisabled"
      :max-points="maxPoints"
      :allow-quick-score="checklistCriteria.requiresReview != true"
      :allow-quick-max-points="checklistCriteria.allowQuickMaxPoints"
      :show-points-label="true"
    />
    <!-- <div class="flex flex-row items-center">
      <span
        v-if="isDisabled != true && checklistCriteria.requiresReview != true"
        class="flex flex-row items-center mr-2"
      >
        <BaseIconButton
          color="success"
          @click="awardFullPoints"
          v-if="criteriaInstance.maxPoints"
        >
          <icon name="ic:baseline-check" />
        </BaseIconButton>

        <BaseIconButton
          color="danger"
          @click="awardZeroPoints"
          v-if="criteriaInstance.maxPoints"
        >
          <icon name="ic:baseline-close" />
        </BaseIconButton>
      </span>

      <BaseTextInput
        class="w-[50px] mr-2 text-center"
        :value="earnedPoints"
        @input="updateScore"
        :disabled="isDisabled"
        @focus="onFocus"
      ></BaseTextInput>

      <span v-if="maxPoints != undefined && !Number.isNaN(maxPoints)"
        >/ {{ maxPoints }} points</span
      >
    </div> -->
  </div>
</template>

<style scoped></style>
